export default __webpack_public_path__ + "static/media/flagLBIcon.9e1a0a79.svg";